import cn from "classnames";
import styles from "./ReviewBadges.module.scss";
import { ReviewItem, ReviewType } from "./ReviewItem";

export type ReviewBadgesProps = {
  className?: string;
  items: {
    type: ReviewType;
    rate: number;
    link?: string;
  }[];
};

export const ReviewBadges = ({ className, items }: ReviewBadgesProps) => {
  return (
    <>
      <div className={cn(styles.wrapper, className)}>
        <ul className={styles.inner}>
          {items.map((item) => (
            <ReviewItem key={item.type} className={styles.item} tag="li" {...item} />
          ))}
        </ul>
      </div>
    </>
  );
};

export default ReviewBadges;
